export const normalizeUrl = (url: string) => {
  return url ? (url.endsWith('/') ? url : `${url}/`) : '';
};

export function isValidUrl(value: string) {
  let url;

  try {
    url = new URL(value);
  } catch {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}
